import React from 'react'
import SwiperCore, { Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components'
import { Navigation } from 'swiper'
import { Banner } from '../../apis/response_types'
import 'swiper/swiper-bundle.min.css'
import SwiperButtonPrev from '../landingpage/assets/swiper_button_left.svg'
import SwiperButtonNext from '../landingpage/assets/swiper_button_right.svg'

SwiperCore.use([Pagination, Autoplay])
// https://swiper6.vercel.app

export default function CarouselBanner(props: { banners: Banner[] }) {
  const bannersDuplicated: Banner[] = [
    ...props.banners,
    ...props.banners,
    ...props.banners,
    ...props.banners,
    ...props.banners,
    ...props.banners,
    ...props.banners,
    ...props.banners,
    ...props.banners,
    ...props.banners
  ]
  const swiperParams = {
    loop: true, // ループ:有効
    autoplay: { delay: 5000 },
    centeredSlides: true,
    slidesPerView: 'auto' as any, // 一度に表示する枚数
    spaceBetween: 20, // 要素間のmargin
    modules: [Navigation], // 使用するSwiperのモジュール
    navigation: {
      // 前後の矢印
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      1100: {
        // 画面幅 >= 指定したpx の場合
        slidesPerView: 'auto' as any
      }
    }
  }
  return (
    <>
      <StyledSwiper {...swiperParams}>
        {/* Swiperのループを正常動作させるには、(slidesPerView * 2)以上の要素数が必要なため、カルーセルの要素を多重出力する */}
        {bannersDuplicated.map((b, i) => {
          return (
            <SwiperSlide key={i}>
              <a href={b.url} target="_blank">
                <img src={b.image_url} alt={b.title} />
              </a>
            </SwiperSlide>
          )
        })}
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </StyledSwiper>
    </>
  )
}

const StyledSwiper = styled(Swiper)`
  overflow: unset !important;
  .swiper-slide {
    width: 300px !important;
    border-radius: 6px;
    overflow: hidden;
    outline: 4px solid rgba(0, 0, 0, 0.14);
    opacity: 0.15;
    img {
      width: 300px;
      height: 100px;
      object-fit: cover;
    }
  }
  .swiper-slide-active,
  .swiper-slide-prev,
  .swiper-slide-next {
    opacity: 1;
  }
  .swiper-slide-prev,
  .swiper-slide-next {
    @media (max-width: 640px) {
      opacity: 0.15;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    height: 48px;
    width: 48px;
    @media (max-width: 640px) {
      height: 32px;
      width: 32px;
    }
    &:hover {
      opacity: 0.8;
    }
    &:after {
      content: '';
      height: 48px;
      width: 48px;
      @media (max-width: 640px) {
        height: 32px;
        width: 32px;
      }
    }
  }
  .swiper-button-prev {
    @media (max-width: 640px) {
      left: 6px;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    @media (min-width: 1100px) {
      left: 50%;
      transform: translateX(-562px);
    }
    &:after {
      background-image: url(${SwiperButtonPrev});
      background-size: 100%;
    }
  }
  .swiper-button-next {
    @media (max-width: 640px) {
      right: 6px;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    @media (min-width: 1100px) {
      left: 50%;
      transform: translateX(512px);
    }
    &:after {
      background-image: url(${SwiperButtonNext});
      background-size: 100%;
    }
  }
`
